import { FC } from 'react'
import { times } from 'lodash'
import { useAppSelector } from '../../../../redux'
import { CoursePreviewCard } from '..'
import { StyledCoursePreviewHeading } from '.'

const CoursePreviewHeading: FC = () => {
  const { course, loading } = useAppSelector((state) => state.course)

  return (
    <StyledCoursePreviewHeading $loading={loading}>
      <div className="width-controller">
        <div className="heading">
          <h1>{!loading && course?.title}</h1>
          <p>
            {!loading && course?.previewDescription}
            {loading && (
              <div className="skel">
                {times(4, (index) => {
                  return <div key={index} />
                })}
              </div>
            )}
          </p>
        </div>
        <CoursePreviewCard />
      </div>
    </StyledCoursePreviewHeading>
  )
}

export default CoursePreviewHeading
